export function getPathFromUrl(url: string) {
  const parsedUrl = new URL(url)
  const path = parsedUrl.pathname
    .split('/')
    .filter((segment) => segment !== '')[0]
  return path || ''
}
